// import { t, Trans } from '@lingui/macro'
import Typography from '@material-ui/core/Typography'

import ErrorLayout from 'components/layout/ErrorLayout'
import Link from 'components/Link'

const InvalidLinkView = () => {
  return (
    <ErrorLayout title='This link is invalid' description='This link is invalid'>
      <Typography
        align="center"
      >
        <Link to="/">
         Back
        </Link>
      </Typography>
    </ErrorLayout>
  )
}

export default InvalidLinkView
